import { useTranslation } from '@/hooks/useTranslation';
import { GeneralLayout } from '@/components/layout/GeneralLayout';
import { AIContentInterface } from './AIContentInterface';
import { AIChatActions } from './AIChatActions';

export const AIChatPage = () => {
  const { t } = useTranslation();

  return (
    <GeneralLayout
      headerText={t('aiChat.pageTitle')}
      contentClassName="!mt-0 h-full overflow-hidden"
      mainTagClassName="!h-screen !pb-0 !mb-0"
      headerRightContent={<AIChatActions />}
    >
      <div className="h-screen pt-16">
        <AIContentInterface />
      </div>
    </GeneralLayout>
  );
};
